// We use hash history because this example is going to be hosted statically.
// Normally you would use browser history.
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();